import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ConnectPage from "@/pages/ConnectPage";
import AboutPage from "@/pages/AboutPage";
import OurWorkPage from "@/pages/OurWorkPage";
import OurPeoplePage from "@/pages/OurPeoplePage";
import TalentProfilePage from "@/pages/TalentProfilePage";
import StoriesMovePage from "@/pages/StoriesMovePage";
import StoriesCulturePage from "@/pages/StoriesCulturePage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import PodcastPage from "@/pages/PodcastPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminBlogListPage from "@/pages/AdminBlogListPage";
import AdminBlogEditPage from "@/pages/AdminBlogEditPage";
import AdminPodcastListPage from "@/pages/AdminPodcastListPage";
import AdminPodcastEditPage from "@/pages/AdminPodcastEditPage";
import AdminTalentPage from "@/pages/AdminTalentPage";
import AdminInquiriesPage from "@/pages/AdminInquiriesPage";
import { AdminLayout } from "@/components/AdminLayout";
import ComingSoon from "@/pages/ComingSoon";

function App() {
  return (
    <div className="App font-sans antialiased bg-white text-[#121212]">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="blog" element={<AdminBlogListPage />} />
            <Route path="blog/new" element={<AdminBlogEditPage />} />
            <Route path="blog/:id/edit" element={<AdminBlogEditPage />} />
            <Route path="podcast" element={<AdminPodcastListPage />} />
            <Route path="podcast/new" element={<AdminPodcastEditPage />} />
            <Route path="podcast/:id/edit" element={<AdminPodcastEditPage />} />
            <Route path="talent" element={<AdminTalentPage />} />
            <Route path="inquiries" element={<AdminInquiriesPage />} />
          </Route>
          <Route
            path="*"
            element={
              <>
                <a href="#main-content" className="skip-link" data-testid="skip-to-content">
                  Skip to content
                </a>
                <Navbar />
                <main id="main-content" tabIndex={-1}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/connect" element={<ConnectPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/our-work" element={<OurWorkPage />} />
                    <Route path="/our-people" element={<OurPeoplePage />} />
                    <Route path="/our-people/:slug" element={<TalentProfilePage />} />
                    <Route path="/stories-move" element={<StoriesMovePage />} />
                    <Route path="/stories-culture" element={<StoriesCulturePage />} />
                    <Route path="/blog" element={<BlogListPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/podcast" element={<PodcastPage />} />
                    <Route
                      path="*"
                      element={
                        <ComingSoon
                          title="Page Not Found"
                          blurb="The page you are looking for does not exist yet. The redesigned site is being built in phases — start from the homepage."
                        />
                      }
                    />
                  </Routes>
                </main>
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
